import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button2',
  standalone: true,
  imports: [],
  templateUrl: './button2.component.html',
  styleUrl: './button2.component.scss',
})
export class Button2Component {
  @Input() buttonText!: string;
}
